export default {"src":"/_next/static/media/key_40.f5793412.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};